import { useTranslation } from 'react-i18next';
import Markdown from 'shared/components/Markdown';
import { SPACINGS } from 'shared/styles/variables';
import styled from 'styled-components';

import ImageDocumentFailed from 'images/pictographs/document-failed.svg';
import Button, { ButtonType } from 'inquiry/components/Button';
import CenteredPictograph from 'verify/components/CenteredPictograph';
import PositionableButtonContainer from 'verify/components/PositionableButtonContainer/PositionableButtonContainer';
import ThemedParagraph from 'verify/components/ThemedParagraph';
import ThemedSvg from 'verify/components/ThemedSvg';
import ThemedTitle from 'verify/components/ThemedTitle';
import { MIN_HEIGHTS } from 'verify/styles/variables';

const Header = styled('div')`
  min-height: ${MIN_HEIGHTS.header};
  margin-bottom: ${SPACINGS.base * 4}px;
`;

interface VerifyDocumentFailedViewProps {
  handleRetry: () => void;
}

export default function VerifyDocumentFailedView(props: VerifyDocumentFailedViewProps) {
  const [t] = useTranslation();

  return (
    <>
      <Header>
        <ThemedTitle>
          <Markdown>{t('documents.failed.title')}</Markdown>
        </ThemedTitle>
        <ThemedParagraph>
          <Markdown>{t('documents.failed.prompt')}</Markdown>
        </ThemedParagraph>
      </Header>

      {/* Note: If support for failure reasons is added, please also respect the showFailureReasonPictographs theme attribute. */}

      <CenteredPictograph aria-label='document failed pictograph'>
        <ThemedSvg>
          <ImageDocumentFailed />
        </ThemedSvg>
      </CenteredPictograph>

      <PositionableButtonContainer>
        <Button
          id='document-failed__retry'
          buttonType={ButtonType.Primary}
          onClick={props.handleRetry}
        >
          {t('documents.failed.btn-submit')}
        </Button>
      </PositionableButtonContainer>
    </>
  );
}
